/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsDeleteVersion } from "../../funcs/llmSkillsDeleteVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteSkillVersionRequest$inboundSchema,
};

export const tool$llmSkillsDeleteVersion: ToolDefinition<typeof args> = {
  name: "llm-skills-delete-version",
  description: `Delete skill version

Delete a specific version of a skill.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsDeleteVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
